export default __webpack_public_path__ + "static/about-afc387cc5ac6f96e906672b5a43bf589.png";